<template>
  <div class="payment-method" :class="{ 'payment-method--embedded': embedded }">
    <h3 v-if="!embedded">{{ st('finance.paymentMethodRegistrationTitle') }}</h3>
    <div class="content result-content" v-if="bindStep === 'success'">
      <p class="prompt">Add Payment Method</p>
      <div class="success-img-container">
        <img src="../../assets/images/img/success.png" alt="success" class="success-img">
      </div>
      <p class="result-text">{{ st('finance.paymentMethodBindSuccess') }}</p>
      <artmisads-button class="result-btn" type="primary" @click="onComplete">
        Confirm
      </artmisads-button>
    </div>
    <div class="content result-content" v-else-if="bindStep === 'failed'">
      <p class="prompt">Add Payment Method</p>
      <div class="success-img-container">
        <img src="../../assets/images/img/failed.png" alt="success" class="success-img">
      </div>
      <p class="result-text">Payment Method Adding Failed</p>
      <artmisads-button class="result-btn" type="primary" @click="onRetry">
        Try Again
      </artmisads-button>
    </div>
    <div class="content" v-else>
      <a-spin :spinning="cardListBlockLoading">
      <p class="prompt">Add Payment Method</p>
      <p class="prompt-content">Choose how you'd like to connect your account</p>
      <div class="method-options">
        <div class="method-item" :class="{ selected: methodType === 'CARD' }" @click="methodType = 'CARD'">
          <Icon name="yinhangka" class="card-icon" />
          {{ st('finance.paymentMethodCreditCardTitle') }}
          <Icon name="success-tianchong" class="success-icon" v-if="methodType === 'CARD'"/>
        </div>
        <div class="method-item" :class="{ selected: methodType === 'ALIPAY_CN' }" @click="methodType = 'ALIPAY_CN'">
          <Icon name="zhifubao" class="card-icon" />
          {{ st('finance.paymentMethodAlipay') }}
          <Icon name="success-tianchong" class="success-icon" v-if="methodType === 'ALIPAY_CN'" />

        </div>
      </div>
      <p class="notice">
        To ensure timely payment processing, ArtemisAds requires you to authorize a linked credit card or Alipay account during registration.
      </p>
      <p class="notice">
        The authorization process is securely provided by Antom, Alipay’s payment technology service provider.
      </p>
      <p class="notice">
        You can contact your ArtemisAds account manager later to unlink your payment method.
      </p>
      <artmisads-button class="auth-btn" type="primary" :loading="binding" @click="startAuthorization" :disabled="!methodType">
        Authorize & Connect
      </artmisads-button>
    </a-spin>
    </div>
    <div class="footer">
      <span class="footer-text">{{ st('finance.paymentMethodTechSupport') }}</span>
      <img class="footer-img" src="../../assets/images/img/footOne.png" alt="Alipay">
        <div class="vertical"></div>
      <img src="../../assets/images/img/footTwo.png" alt="Antom">
    </div>
  </div>
</template>
<script setup>
import { ref, onBeforeUnmount, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { financeApi } from '~/server'
import { useSellerI18n } from '@/composables/useSellerI18n'
import { AMSAutoDebit, AMSAutoDebitPay, AMSCashierPayment, AMSEasyPay, AMSVaulting } from '@alipay/ams-checkout'
import { useUserInfoStore } from '@/storeData'
import Icon from '@/components/Icon.vue'
import jwt from 'jsonwebtoken'
import { useRoute } from 'vue-router';
const route = useRoute();
const { st, locale } = useSellerI18n()
const store = useUserInfoStore()
defineProps({
  embedded: {
    type: Boolean,
    default: false,
  },
})

const methodType = ref('')
const binding = ref(false)
const bindStep = ref('')
const alipayCheckout = ref()
const alipayCheckoutSdkName = ref('AMSEasyPay')
const alipayCheckoutConfig = ref(null)

const resolveCheckoutLocale = () => {
  if (locale.value === 'zh-CN') {
    return 'zh_CN'
  }
  return 'en_US'
}
// 绑定成功后切换token
const bindSuccessSwitchToken = async () => {
  const response = await financeApi.financeSellerRegistrationCompletePaymentBinding()
  // console.log(response,'response',userInfo)
    if (response.success) {
      const userToken = response.data.token
      const userInfo = jwt.decode(userToken);
      store.setUserInfo(userInfo, userToken, menus.value)
      binding.value = false
      bindStep.value = 'success'
    } else {
      binding.value = false
      bindStep.value = 'failed'
    }
}

const onComplete = () => {
  sessionStorage.removeItem(`${location.hostname}_profileConnectingStep`)
  location.href = '/seller/dashboard'
}

const onRetry = () => {
  bindStep.value = 'form'
  binding.value = false
  alipayCheckoutConfig.value = null
  if (alipayCheckout.value) {
    alipayCheckout.value.unmount()
    alipayCheckout.value = undefined
  }
}

const showBindFailed = () => {
  binding.value = false
  bindStep.value = 'failed'
  cardListBlockLoading.value = false
}
const normalizeBankBindStartResponse = (response) => {
  const rawData = response?.data || response
  return normalizeCheckoutConfig({
    ...rawData,
    paymentSessionData: rawData?.paymentSessionData || rawData?.sessionData || rawData?.vaultingSessionData,
    sessionData: rawData?.sessionData || rawData?.paymentSessionData || rawData?.vaultingSessionData,
    requestId: rawData?.requestId || rawData?.bindRequestId,
  })
}

const getSessionParts = (paymentSessionData) => {
  if (!paymentSessionData || typeof paymentSessionData !== 'string') {
    return []
  }
  return paymentSessionData.split('&&')
}

const normalizeCheckoutConfig = (config) => {
  if (!config) {
    return null
  }
  const paymentSessionData = config.paymentSessionData || config.sessionData
  if (!paymentSessionData) {
    return null
  }
  const checkoutEnvFromHost =
    typeof window !== 'undefined' && window.location.origin === 'https://www.artemisads.com'
      ? 'prod'
      : 'sandbox'

  return {
    paymentSessionData,
    environment: config.environment || checkoutEnvFromHost,
    locale: config.locale || resolveCheckoutLocale(),
    merchantId: config.merchantId,
    securityRegion: config.securityRegion || resolveSecurityRegionFromSession(paymentSessionData) || 'SG',
    merchantAppointParam: config.merchantAppointParam,
    notRedirectAfterComplete: config.notRedirectAfterComplete !== false,
  }
}

const decodeCheckoutSessionMeta = (paymentSessionData) => {
  if (!paymentSessionData || typeof window === 'undefined') {
    return null
  }
  try {
    const encodedMeta = paymentSessionData.split('&&')[3]
    if (!encodedMeta) {
      return null
    }
    return JSON.parse(window.atob(encodedMeta))
  } catch {
    return null
  }
}

const resolveCheckoutSdk = (paymentSessionData) => {
  const sessionMeta = decodeCheckoutSessionMeta(paymentSessionData)
  const productScene = sessionMeta?.paymentSessionConfig?.productScene

  if (productScene === 'VAULTING') {
    return { sdkName: 'AMSVaulting', sdkClass: AMSVaulting }
  }
  if (productScene === 'CASHIER_PAYMENT') {
    return { sdkName: 'AMSCashierPayment', sdkClass: AMSCashierPayment }
  }
  if (productScene === 'AUTO_DEBIT') {
    return { sdkName: 'AMSAutoDebit', sdkClass: AMSAutoDebit }
  }
  if (productScene === 'AUTO_DEBIT_PAY') {
    return { sdkName: 'AMSAutoDebitPay', sdkClass: AMSAutoDebitPay }
  }
  return { sdkName: 'AMSEasyPay', sdkClass: AMSEasyPay }
}

const resolveSecurityRegionFromSession = (paymentSessionData) => {
  const region = getSessionParts(paymentSessionData)[1]
  if (['SG', 'US', 'DE'].includes(region)) {
    return region
  }
  return undefined
}

const initAlipayCheckout = () => {
  if (!alipayCheckoutConfig.value) {
    return false
  }
  if (alipayCheckout.value) {
    return true
  }
  try {
    const { environment, locale, redirectUrl, merchantId, securityRegion, paymentSessionData } = alipayCheckoutConfig.value
    const { sdkClass, sdkName } = resolveCheckoutSdk(paymentSessionData)
    alipayCheckoutSdkName.value = sdkName
    const options = {
      environment,
      locale,
      redirectUrl,
      securityRegion,
      onError: (error) => {
        console.error('[ProfileCheckout] onError:', error)
        showBindFailed()
      },
      onEventCallback: (event) => {
        console.log("[DashboardCheckout] onEventCallback:", event)
        if (event.code === 'SDK_ASSET_BINDING_SUCCESSFUL' || event.code === 'SDK_ASSET_BINDING_PROCESSING') {
          // 成功后调用后端接口
          pollCardListUntilUpdated()
        }
        if (event.code === 'SDK_ASSET_BINDING_FAIL') {
          showBindFailed()
        }
      },
      onClose: (...args) => {
        binding.value = false
      },
    }
    if (merchantId) {
      options.merchantId = merchantId
    }
    alipayCheckout.value = new sdkClass(options)
    return true
  } catch (error) {
    console.error('Failed to initialize checkout:', error)
    message.error(st('finance.paymentMethodFailedInitCheckout'))
    return false
  }
}

const bindCard = async () => {
  if (!alipayCheckoutConfig.value) {
    const response = await financeApi.financeSellerBankBindStart({
      provider: 'ANTOM',
      instrumentKind: 'CARD',
    })
    const nextConfig = normalizeBankBindStartResponse(response)
    if (!nextConfig) {
      message.warning(response?.error || st('finance.paymentMethodMissingCheckoutSession'))
      showBindFailed()
      return
    }
    if (alipayCheckout.value) {
      alipayCheckout.value.unmount()
      alipayCheckout.value = undefined
    }
    alipayCheckoutConfig.value = nextConfig
  }
  if (!initAlipayCheckout()) {
    showBindFailed()
    return
  }
  const { paymentSessionData, merchantAppointParam, notRedirectAfterComplete } = alipayCheckoutConfig.value
  await alipayCheckout.value.createComponent({
    paymentSessionData,
    merchantAppointParam,
    notRedirectAfterComplete,
  })
}

const bindAlipay = async () => {
  const response = await financeApi.financeSellerBankBindStart({
    provider: 'ANTOM',
    instrumentKind: 'ALIPAY_CN',
    fromRegister: true,
  })
  const url = response?.data?.normalUrl
  if (!url) {
    message.warning(response?.data?.error || response?.error || st('finance.paymentMethodMissingBindUrl'))
    showBindFailed()
    return
  }
  window.open(url, '_blank')
}

const startAuthorization = async () => {
  if (binding.value) {
    return
  }
  binding.value = true
  try {
    if (methodType.value === 'CARD') {
      await bindCard()
    } else {
      await bindAlipay()
      // pollAlipayListUntilUpdated()
    }
  } catch (error) {
    console.error('Failed to start authorization:', error)
    message.error(error?.message || st('finance.paymentMethodFailedStartAuthorization'))
    showBindFailed()
  } finally {
    // binding.value = false;
  }
}

onBeforeUnmount(() => {
  if (alipayCheckout.value) {
    alipayCheckout.value.unmount()
    alipayCheckout.value = undefined
  }
  stopCardListPoll()
  stopAlipayListPoll()
})
const getCardList = async (opts = {}) => {
  const { withBlockLoading = false } = opts
  if (withBlockLoading) {
    cardListBlockLoading.value = true
  }
  try {
    const response = await financeApi.financeSellerBankInstrumentList({
      page: 1,
      pageSize: 100,
      instrumentKind: "CARD",
      provider: "ANTOM",
      status: 'ACTIVE',
    })
    cardList.value = response.data.data

  } finally {
    if (withBlockLoading) {
      cardListBlockLoading.value = false
    }
  }
}
const CARD_LIST_POLL_INTERVAL_MS = 2000
const CARD_LIST_POLL_MAX_ATTEMPTS = 15
let cardListPollTimer = null
const cardListBlockLoading = ref(false)
const cardList = ref([])
const alipayListBlockLoading = ref(false)
const alipayList = ref([])
const stopCardListPoll = () => {
  cardListBlockLoading.value = false
  if (cardListPollTimer != null) {
    clearTimeout(cardListPollTimer)
    cardListPollTimer = null
  }
}

let alipayListPollTimer = null

const stopAlipayListPoll = () => {
  if (alipayListPollTimer != null) {
    clearTimeout(alipayListPollTimer)
    alipayListPollTimer = null
  }
}

/** 绑卡成功后后端列表可能延迟，轮询列表直到条数增加或超时 */
const pollCardListUntilUpdated = () => {
  stopCardListPoll()
  cardListBlockLoading.value = true
  const baselineLength = cardList.value.length
  let attempts = 0

  const run = async () => {
    attempts += 1
    try {
      await getCardList()
    } catch (e) {
      console.error("[DashboardCheckout] poll getCardList:", e)
    }
    const nextLen = Array.isArray(cardList.value) ? cardList.value.length : 0
    if (nextLen > baselineLength) {
      cardListBlockLoading.value = false
      bindSuccessSwitchToken()
      stopCardListPoll()
      return
    }
    if (attempts >= CARD_LIST_POLL_MAX_ATTEMPTS) {
      cardListBlockLoading.value = false
      stopCardListPoll()
      showBindFailed()
      return
    }
    cardListPollTimer = window.setTimeout(() => void run(), CARD_LIST_POLL_INTERVAL_MS)
  }

  void run()
}

/** 支付宝授权回调后列表可能延迟，轮询直到条数增加或超时（与绑卡轮询逻辑一致） */
const pollAlipayListUntilUpdated = () => {
  stopAlipayListPoll()
  alipayListBlockLoading.value = true
  const baselineLength = Array.isArray(alipayList.value) ? alipayList.value.length : 0
  let attempts = 0

  const run = async () => {
    attempts += 1
    try {
      await getAlipayList()
    } catch (e) {
      console.error("[DashboardCheckout] poll getAlipayList:", e)
    }
    const nextLen = Array.isArray(alipayList.value) ? alipayList.value.length : 0
    if (nextLen > baselineLength) {
      alipayListBlockLoading.value = false
      bindSuccessSwitchToken()
      stopAlipayListPoll()
      return
    }
    if (attempts >= CARD_LIST_POLL_MAX_ATTEMPTS) {
      alipayListBlockLoading.value = false
      stopAlipayListPoll()
      showBindFailed()
      return
    }
    alipayListPollTimer = window.setTimeout(() => void run(), CARD_LIST_POLL_INTERVAL_MS)
  }

  void run()
}

const getAlipayList = async (opts = {}) => {
  const { withBlockLoading = false } = opts
  if (withBlockLoading) {
    alipayListBlockLoading.value = true
  }
  try {
    const response = await financeApi.financeSellerBankInstrumentList({
      page: 1,
      pageSize: 100,
      instrumentKind: "ALIPAY_CN",
      provider: "ANTOM",
      status: 'ACTIVE',
    })
    alipayList.value = response.data.data
 
  } finally {
    if (withBlockLoading) {
      alipayListBlockLoading.value = false
    }
  }
}
const menus = ref()
const userInfo = ref()
onMounted(async () => {
  menus.value = store.userInfo.menus
  userInfo.value = store.userInfo
  const { authCode, authState } = route.query;
  if(authCode && authState) {
   await bindSuccessSwitchToken()
   return
  }
  await getAlipayList()
  await getCardList()
 
  // bindSuccessSwitchToken()
  // pollAlipayListUntilUpdated()
})
</script>
<style lang="less" scoped>
.card-icon{
  width: 24px;
  height: 24px;
}
.success-icon{
  width: 20px;
  height: 20px;
  color: rgba(138, 100, 244, 1);
}
.success-img-container{
      width: 110px;
      height: 110px;
      margin-top: 32px;
    }
.payment-method {
  display: flex;
  flex-direction: column;
  margin-left: -90px;

  &--embedded {
    margin-left: 0;
    width: 100%;

    .content {
      margin-top: 24px;
      width: 560px;
    }
  }

  h3 {
    font-family: Sora, sans-serif;
    font-weight: 600;
    color: var(--dark-1);
  }

  .content {
    margin-top: 24px;
    width: 560px;
    padding: 21px 32px;
    background: var(--color-white);
    box-shadow: var(--section-box-shadow-2);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .prompt {
    font-family: Sora;
    font-weight: 700;
    font-style: Bold;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    color: rgba(15, 6, 41, 1);
  }

  .prompt-content {
    margin-top: 12px;
    margin-bottom: 32px;
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    color: rgba(15, 6, 41, 0.5);
  }

  .method-options {
    display: flex;
    gap: 16px;
    width: 100%;
    margin-bottom: 24px;
  }

  .method-item {
    flex: 1;
    height: 58px;
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    border: 2px solid #d9d5e3;
    border-radius: 8px;
    font-family: Sora, sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: var(--dark-1);
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;

    &:hover {
      border:2px solid rgba(138, 100, 244, 1);
    }

    &.selected {
      color: rgba(138, 100, 244, 1);
      border:2px solid rgba(138, 100, 244, 1);
      background: rgba(245, 243, 255, 1);
    }
  }

  .notice {
    font-family: Inter;
font-weight: 400;
font-style: Regular;
font-size: 12px;
leading-trim: NONE;
line-height: 150%;
letter-spacing: 0%;
color: rgba(156, 163, 175, 1);
  }

  .auth-btn {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 24px;
    margin-top: 24px;
    background-color: rgba(108, 61, 242, 1);
    color: #fff;

  }

  .result-content {
    min-height: 240px;
    padding: 56px 32px;
    justify-content: center;
  }

  .result-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 22px;

    .icon {
      width: 32px;
      height: 32px;
      fill: rgba(255, 255, 255, 0.85);
    }

    &--success {
      background-color: var(--green-5);
      box-shadow: 0 0 0 7px var(--green-6);
    }

    &--failed {
      background-color: var(--error-1);
      box-shadow: 0 0 0 7px var(--error-2);
    }
  }

  .result-text {
    font-family: Sora;
font-weight: 500;
font-style: Medium;
font-size: 16px;
leading-trim: NONE;
line-height: 100%;
letter-spacing: 0%;
text-align: center;
color: rgba(15, 6, 41, 1);
margin-top: 20px;
margin-bottom: 32px;
  }

  .result-btn {
    width:200px;
    height: 44px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    background-color: rgba(108, 61, 242, 1);
    color: #fff;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    gap: 12px;
    .footer-text {
    font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 13px;
leading-trim: NONE;
line-height: 100%;
letter-spacing: 0%;
text-align: center;
color:rgba(15, 6, 41, 0.5)
    }

    .footer-img {
      height: 30px;
    
    }
    .vertical{
      width: 1px;
      height: 14px;
      background-color: rgba(232, 229, 237, 1);
    }
    img:last-child {
      height: 30px;
    }
  }
}
</style>
